import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { ObtenerTiposClientesEnAPI, ActualizarTiposClientesEnAPI } from "../../action/actionCreatorsRequests"
import { traducirPagina, obtenerUsuario } from '../../librerias/funciones'

import {
    CloseOutlined,
    DeleteOutlined,
    EditOutlined,
    EyeOutlined,
    SearchOutlined
} from '@ant-design/icons';

import { Select, Col, Drawer } from 'antd';
import FichaCrudTipoCliente from './FichaCrudTipoCliente';

const { Option } = Select;
const MantenimientoTipoCliente = ({ props, usuario }) => {
    const [hayRegristros, setHayRegristros] = React.useState(false);
    const [textoBuscador, setTextoBuscador] = React.useState("");
    const [categoriaDocumento, setCategoriaDocumento] = React.useState([])
    const [abrirFichaCatDocumento, setAbrirFichaCatDocumento] = React.useState(false);
    const [registroSeleccionado, setRegistroSeleccionado] = React.useState({});
    const [sociosLocal, setSociosLocal] = React.useState([]);
    const [socioSeleccionado, setSocioSeleccionado] = React.useState(0);



    const GetCategoriaDocumento = (ID, ID_SOCIO) => {
        ObtenerTiposClientesEnAPI(ID, ID_SOCIO).then((licencia) => {
            if (licencia !== undefined && licencia !== null && licencia.REGISTROS !== null && licencia.REGISTROS.length > 0) {
                setCategoriaDocumento(licencia.REGISTROS)
            } else {
                setCategoriaDocumento(null)

            }
        })
    }


    const modificarRegistro = (ID) => {
        ActualizarTiposClientesEnAPI(2, ID, socioSeleccionado).then((licencia) => {
            GetCategoriaDocumento(null, socioSeleccionado);

        })
    }



    const filtroLocalDeLaTabla = (textoAFiltrar, registros) => {
        let resultado = []

        if (textoAFiltrar.trim() !== "") {
            if (registros !== null) {

                let resultadoFiltro = registros.filter((item) => {
                    return item.NOMBRE.toUpperCase().includes(textoAFiltrar.toUpperCase()) ||
                        item.DESCRIPCION.toUpperCase().includes(textoAFiltrar.toUpperCase())
                })

                if (resultadoFiltro.length > 0) {
                    resultado = resultadoFiltro;
                } else {
                    resultado = [];
                }
            }
        } else {
            resultado = registros;
        }
        return resultado
    }



    if (!hayRegristros && props.ABRIR_FICHA) {
        setHayRegristros(true);
        let ID_SOCIO_SELECCIONADO = props.SOCIO_SELECCIONADO === undefined || props.SOCIO_SELECCIONADO === null || props.SOCIO_SELECCIONADO === -1 ? null : props.SOCIO_SELECCIONADO
        let accesoLicencia = obtenerUsuario();
        setSociosLocal(accesoLicencia.SOCIOS)

        if (ID_SOCIO_SELECCIONADO === null) {
            ID_SOCIO_SELECCIONADO = accesoLicencia.SOCIOS[0].ID_SOCIO
            setSocioSeleccionado(ID_SOCIO_SELECCIONADO)

        } else {
            setSocioSeleccionado(ID_SOCIO_SELECCIONADO)

        }

        GetCategoriaDocumento(null, ID_SOCIO_SELECCIONADO);

    } else {
        if (!props.ABRIR_FICHA && hayRegristros) {
            setCategoriaDocumento([])
            setHayRegristros(false)
        }
    }


    return (
        <div>
            <Drawer
                width={800}
                onClose={() => {
                    if (props.TIPO === "MASTER") {
                        props.CERRAR.setState({ ABRIR_FICHA_TIPO_CLIENTE: false })
                    } else {
                        props.CERRAR_FICHA(false)
                    }

                    props.ACTUALIZAR_TABLA()
                }}
                visible={props.ABRIR_FICHA}
                closable={false}
                placement={"right"}
                bodyStyle={{ padding: '0px' }}
                style={{ color: '#fff' }}>



                <div className='containerHeaderDrawer'>
                    <div className='itemHeaderDrawer1'>
                        <CloseOutlined onClick={(e) => {
                            if (props.TIPO === "MASTER") {
                                props.CERRAR.setState({ ABRIR_FICHA_TIPO_CLIENTE: false })
                            } else {
                                props.CERRAR_FICHA(false)
                            }
                            props.ACTUALIZAR_TABLA()

                        }}></CloseOutlined >
                        <div> {props.title}</div>
                    </div>

                    <div className='itemHeaderDrawer2'>

                    </div>
                </div>

             


                <div className="centerMenu2" style={{backgroundColor:'#fff',border:'1px solid #dcdcdc'}}>
                    <div style={{ fontSize: '16px', fontWeight: '500', display: 'flex', height: '40px', justifyContent: 'space-between' }}>

                        <div style={{ textAlign: 'left' }} className="mdb-skin">
                          


                            {sociosLocal !== null ?
                                <Select
                                    showSearch
                                    allowClear={false}
                                    size={"large"}

                                    value={socioSeleccionado === 0 ? <span style={{ color: '#999' }}>{traducirPagina("Seleccione_socio").toUpperCase()}</span> : socioSeleccionado}

                                    style={{ width: "300px", textAlign: 'left', marginRight: '10px' }}
                                    optionFilterProp="children"
                                    onChange={(e) => {

                                        let SOCIO_ACTUAL = e === undefined || e === null ? 0 : parseInt(e);

                                        setSocioSeleccionado(SOCIO_ACTUAL);

                                        GetCategoriaDocumento(null, SOCIO_ACTUAL);


                                    }}
                                    filterOption={(input, option) =>
                                        option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                    }
                                >
                                    {sociosLocal.length > 0 ?
                                        sociosLocal.map((socio) =>
                                            <Option key={socio.ID_SOCIO} value={socio.ID_SOCIO}>{socio.NOMBRE_SOCIO}</Option>
                                        )
                                        :
                                        null
                                    }
                                </Select>
                                :
                                <div style={{ textAlign: 'center' }}>
                                    <h4>{traducirPagina("Info_error_socio")}</h4>
                                </div>
                            }

                        </div>



                        <div className={"botonNuevo"} style={{ backgroundColor: 'var(--azul-claro-serca)', color: 'rgb(255, 255, 255)' }} onClick={() => {
                                setRegistroSeleccionado({ ID: 0 });
                                setAbrirFichaCatDocumento(true);



                            }}>  <span style={{ fontSize: '16px' }}>{traducirPagina("Nuevo_registro").toUpperCase()}</span>
                        </div>

                    </div>
                </div>


                <div className="Container_estadistica_assist">
                    <>
                        <Col span={24} style={{ fontSize: '18px', fontWeight: '500', color: '#000', textAlign: 'center', justifyContent: 'center', alignItems: 'center', padding: '0px 10px' }}>
                            <div style={{ padding: '10px', margin: '10px 0px' }}>

                                {categoriaDocumento === null ?
                                    <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', textAlign: 'center', minHeight: '20vh' }}> <h3>{traducirPagina("Sin_resultados")}</h3> </div>
                                    :
                                    categoriaDocumento !== null && categoriaDocumento.length > 0 ?
                                        <table style={{ border: '1px solid #d9d9d9', width: '100%', color: '#000' }} >
                                            <thead>
                                                <tr style={{ backgroundColor: '#e0e0e0' }}>
                                                    <th style={{ width: '100px', border: '1px solid #d9d9d9', padding: '4px', textAlign: 'left' }}>{"ID"}</th>
                                                    <th style={{ border: '1px solid #d9d9d9', padding: '4px', textAlign: 'left' }} onClick={(e) => { }}>{traducirPagina("Descripcion").toUpperCase()} </th>
                                                    <th style={{ width: '80px', border: '1px solid #d9d9d9', padding: '4px', textAlign: 'left' }} onClick={(e) => { }}>{ } </th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {categoriaDocumento.map((registro, i) =>
                                                    <tr key={i} style={{ backgroundColor: '#fff' }}>
                                                        <td style={{ border: '1px solid #d9d9d9', padding: '4px', textAlign: 'left' }}>{registro.ID}</td>
                                                        <td style={{ border: '1px solid #d9d9d9', padding: '4px', textAlign: 'left' }}>{registro.DESCRIPCION}</td>


                                                        <td style={{ border: '1px solid #d9d9d9', padding: '4px', textAlign: 'center' }}>
                                                            <div className="flex-container-Grow-Simple">

                                                                <div style={{ margin: '0px 2px' }}>
                                                                    <button title={"Editar"} onClick={() => {
                                                                        // window.open("http://sertec.servicenext.eu//?user=" + licencia.USUARIO + "&pass=" + licencia.PWD, '_blank');
                                                                        setRegistroSeleccionado(registro)
                                                                        setAbrirFichaCatDocumento(true)
                                                                    }}
                                                                        className="btn-matricula  estiloBotonRemove paddindDeTres">
                                                                        <EditOutlined style={{ cursor: 'pointer', fontSize: '20px', color: '#000' }} />
                                                                    </button>
                                                                </div>



                                                                <div style={{ margin: '0px 2px' }} >
                                                                    <button title={"Eliminar"} onClick={() => {
                                                                        // MailDeRecuperacion(licencia.ID);
                                                                        modificarRegistro(registro.ID, "", "")
                                                                    }}
                                                                        className="btn-matricula  estiloBotonRemove paddindDeTres">
                                                                        <DeleteOutlined style={{ cursor: 'pointer', fontSize: '20px', color: '#000' }} />
                                                                    </button>
                                                                </div>

                                                            </div>
                                                        </td>

                                                    </tr>

                                                )
                                                }
                                            </tbody>
                                        </table>
                                        :
                                        <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', textAlign: 'center', minHeight: '20vh' }}> <div className="spinner-border  fast colorSubAzul" role="status" disabled /> </div>
                                }
                            </div>


                        </Col>
                    </>
                </div>
            </Drawer>



            {abrirFichaCatDocumento ?
                <FichaCrudTipoCliente
                    title={traducirPagina("Tipo_cliente").toUpperCase()}
                    ABRIR_FICHA={abrirFichaCatDocumento}
                    CERRAR_FICHA={setAbrirFichaCatDocumento}

                    REGISTROS={registroSeleccionado}
                    ID_REGISTRO={registroSeleccionado.ID}
                    ID_SOCIO={socioSeleccionado}
                    ACTUALIZAR_TABLA={GetCategoriaDocumento}

                >
                </FichaCrudTipoCliente>
                :
                null}


        </div>

    )
}



MantenimientoTipoCliente.propTypes = {
    title: PropTypes.string,


    TIPO: PropTypes.string,
    CERRAR: PropTypes.object,
    ABRIR_FICHA: PropTypes.bool,


    ID_USUARIO: PropTypes.number,
    SOCIO: PropTypes.number,
    USUARIO: PropTypes.object,
    RED_SELECCIONADA: PropTypes.object,
    RED: PropTypes.object,

    ACTUALIZAR_TABLA: PropTypes.func,
};

const mapStateToProps = (state, props) => {
    return {
        props: props,
        configApp: state.configApp,
        openDrawerFichaClienteSocio: state.estadoDrawer.openDrawerFichaClienteSocio,
        clienteTallerSeleccionado: state.clienteTallerSeleccionado,
        usuario: state.usuario

    };
}

export default connect(mapStateToProps)(MantenimientoTipoCliente);